<div class="img-viewer-host" [style.height]="height()">
  @if (!isLoaded()) {
    <div class="img-viewer-overlay">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
      <span class="img-viewer-overlay__label">Loading image…</span>
    </div>
  }

  @if (hasError()) {
    <div class="img-viewer-error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Failed to load image.</span>
      <p-button label="Retry" icon="pi pi-refresh" size="small" (onClick)="retry()" />
    </div>
  } @else {
    <p-galleria
      [value]="[src()]"
      [containerStyle]="{ width: '100%', height: height() }"
      [showThumbnails]="false"
      [showIndicators]="false"
      [showItemNavigators]="false"
      [circular]="false"
    >
      <ng-template #item let-item>
        @for (n of [retryCount()]; track n) {
          <img [src]="item" alt="" class="img-viewer-image" (load)="isLoaded.set(true)" (error)="onImageError()" />
        }
      </ng-template>
    </p-galleria>
  }
</div>
